"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Icons_1 = require("./Icons");
var models_1 = require("./models");
var ThumbnailIcon = function (_a) {
    var type = _a.type;
    switch (type) {
        case models_1.FILE_UPLOAD_THUMBNAIL_TYPE.excel:
            return react_1.default.createElement(Icons_1.Excel, null);
        case models_1.FILE_UPLOAD_THUMBNAIL_TYPE.word:
            return react_1.default.createElement(Icons_1.Word, null);
        case models_1.FILE_UPLOAD_THUMBNAIL_TYPE.pdf:
            return react_1.default.createElement(Icons_1.Pdf, null);
        case models_1.FILE_UPLOAD_THUMBNAIL_TYPE.powerPoint:
            return react_1.default.createElement(Icons_1.PowerPoint, null);
    }
};
var THUMBNAIL_SIZE = 240;
var Box = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: relative;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: relative;\n"])), THUMBNAIL_SIZE, THUMBNAIL_SIZE);
var BoxWithBorder = (0, styled_1.default)(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid #c4c4c4;\n"], ["\n  border: 1px solid #c4c4c4;\n"])));
var Icon = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var Thumbnail = function (_a) {
    var type = _a.type, url = _a.url, loading = _a.loading;
    if (loading) {
        return (react_1.default.createElement(Box, null,
            react_1.default.createElement(Icon, null,
                react_1.default.createElement(Icons_1.Loading, null))));
    }
    if (type === models_1.FILE_UPLOAD_THUMBNAIL_TYPE.image) {
        return react_1.default.createElement(Box, { style: { backgroundImage: "url(".concat(url, ")") } });
    }
    return (react_1.default.createElement(BoxWithBorder, null,
        react_1.default.createElement(Icon, null,
            react_1.default.createElement(ThumbnailIcon, { type: type }))));
};
exports.Thumbnail = Thumbnail;
var templateObject_1, templateObject_2, templateObject_3;
